<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    ></v-text-field>
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 150"
      :search="search"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.item }}</td>
          <td>{{ item.note }}</td>
          <td
            v-if="$store.state.auth.userSettings.accItems.update"
            class="px-2 tableSelectCursor"
            @click="((modalEdit = true), (controlledItem = { ...item }))"
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accItems.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="modalEdit" persistent width="70%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.itemForInspection') }}
          <v-spacer />
          <v-icon large @click="modalEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="controlledItemForm">
            <v-row>
              <v-col>
                <v-text-field
                  :label="$tc('label.item')"
                  v-model="controlledItem.item"
                  :rules="[ruleRequired]"
                  maxlength="128"
                  required
                  hide-details
                  dense
                  autofocus
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  :label="$t('label.note')"
                  v-model="controlledItem.note"
                  name="input-7-1"
                  maxlength="512"
                  no-resize
                  hide-details
                  dense
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn v-if="controlledItem.id && $store.state.auth.userSettings.accItems.delete" color="colorDelete" @click="modalDelete = true">
            {{ $tc('btn.delete') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="colorSave" @click="dataSave">{{ $tc('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${controlledItem.item}?`"
      :openDialog.sync="modalDelete"
      v-on:confirm="dataDelete"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import { mdiMagnify, mdiPen, mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsItems',
  components: { DialogConfirmDelete },
  data: () => ({
    modalEdit: false,
    modalDelete: false,
    validForm: false,
    tableData: [],
    search: '',
    controlledItem: {
      id: 0,
      item: null,
      note: null,
    },
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleNumber() {
      const pattern = /^\d+$/;
      return (v: any) => pattern.test(v) || this.$i18n.t('msg.valueMustBeNumber');
    },
    headers: function () {
      return [
        { text: this.$i18n.tc('label.item'), value: 'item' },
        { text: this.$i18n.t('label.note'), value: 'note' },
        { sortable: false, width: '48px' },
      ];
    },
  },
  mounted() {
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/item')
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      const defaults: any = this.$options;
      this.controlledItem = { ...defaults.data().controlledItem };
      this.modalEdit = true;
      this.$nextTick(function () {
        const form: any = this.$refs.controlledItemForm;
        form.validate();
      });
    },
    dataSave() {
      const form: any = this.$refs.controlledItemForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        if (this.controlledItem.id === 0) {
          axios
            .post('/api/v1/item', this.controlledItem)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/item', this.controlledItem)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/item/${this.controlledItem.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalDelete = false;
      this.modalEdit = false;
    },
  },
});
</script>
